import { ACCOUNT_PERMISSIONS } from "./accounts";
import { GROUP_PERMISSIONS } from "./groups";
import { MAINTENANCE_PERMISSIONS } from "./maintenance";
import { SUPPORT_PERMISSIONS } from "./support";
/**
 * Every permission that exists, in one frozen list (`D52`).
 *
 * Three things read it: `apps/api` to gate, `apps/mobile` to hide controls,
 * and the grant check to refuse a name outside it. Per-module
 * catalogues were rejected because architecture rule 6 means `iam` could not
 * then validate a grant naming a `training` permission without the union being
 * assembled at the composition root.
 */
export const PERMISSION_CATALOGUE = Object.freeze([
    ...ACCOUNT_PERMISSIONS,
    ...MAINTENANCE_PERMISSIONS,
    ...SUPPORT_PERMISSIONS,
    ...GROUP_PERMISSIONS,
]);
/** The names alone, for a membership test that does not need descriptions. */
export const PERMISSION_NAMES = Object.freeze(PERMISSION_CATALOGUE.map((permission) => permission.name));
/**
 * The `D52` check, in one function: does this name exist at all?
 *
 * It replaces the foreign key `D52` gave up — the granting use case calls it
 * and refuses a name outside the catalogue, which is what stops the bad row
 * being born. It is NOT an authorization check: matching a required permission
 * against granted ones is `PermissionName.matches` in `@repo/kernel`, because
 * this comparison is exact and would miss `*` and `resource:*`.
 */
export function isCataloguePermissionName(value) {
    return PERMISSION_NAMES.includes(value);
}
/** The entry for a name, or `undefined` — for rendering a description. */
export function findPermission(name) {
    return PERMISSION_CATALOGUE.find((permission) => permission.name === name);
}
//# sourceMappingURL=catalogue.js.map